import { useCallback } from "react";

import Avatar from "@/design/components/Avatar";
import Valkyrie, { viFilmstrip, viGripDotsV, viMusic } from "@sippy-platform/valkyrie";

import { useSortable } from "@dnd-kit/react/sortable";
import { Card, List, ListItem, ListItemAvatar, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { amber, blue, lightGreen, purple, red, teal } from "@mui/material/colors";
import PropTypes from "prop-types";

function CodecItem({ codec, id, index }) {
  const { ref, isDragging } = useSortable({ id, index });

  const getCodecColor = useCallback((codec) => {
    if (codec.startsWith("opus")) return blue[500];
    if (codec.startsWith("h2")) return red[500];
    if (codec.startsWith("g7") || codec.startsWith("alaw") || codec.startsWith("ulaw")) return lightGreen[500];
    if (codec.startsWith("siren")) return teal[500];
    if (codec.startsWith("vp")) return amber[500];
    return purple[500];
  }, []);

  return (
    <Card
      ref={ref}
      sx={(theme) => ({
        ...(isDragging && {
          boxShadow: 1,
          backdropFilter: "blur(5px)",
          backgroundColor: "rgb(248 248 248 / .5) !important",
          ...theme.applyStyles("dark", {
            backgroundColor: "rgb(40 40 45 / .5) !important",
          }),
          position: "relative",
          zIndex: 1,
        }),
      })}
    >
      <List>
        <ListItem disablePadding sx={{ minHeight: 44 }}>
          <ListItemButton sx={{ minHeight: 44, borderRadius: 0, cursor: "move" }}>
            <ListItemAvatar>
              <Avatar
                icon={codec.type === "video" ? viFilmstrip : viMusic}
                color={getCodecColor(codec.codec)}
                px={24}
              />
            </ListItemAvatar>
            <ListItemText
              primary={
                <>
                  {codec.codec}
                  {codec.experimental === "yes" ? (
                    <span style={{ opacity: ".6" }}> &middot; Experimental</span>
                  ) : undefined}
                </>
              }
            />
            <ListItemIcon sx={{ justifyContent: "flex-end" }}>
              <Valkyrie icon={viGripDotsV} />
            </ListItemIcon>
          </ListItemButton>
        </ListItem>
      </List>
    </Card>
  );
}

CodecItem.propTypes = {
  id: PropTypes.number,
  codec: PropTypes.object,
  index: PropTypes.number,
};

export default CodecItem;
